import { ButtonProps } from "antd";
import { ReactNode } from "react";
import { mapClasses } from "../../../../../utils/styles";
import "./style.scss";

export type Props = ButtonProps["style"] & {
  children: ReactNode;
  type?:
    | "primary"
    | "secondary"
    | "default"
    | "disabled"
    | "danger"
    | "link"
    | "outlined";
  small?: boolean;
  id?: string;
  onMouseDown?: (event:any) => void;
  onClick?: () => void;
  classes?: string;
  disabled?: boolean;
  htmlType?: "button" | "submit" | "reset";
};

export const Button = ({
  children,
  small,
  onClick,
  onMouseDown,
  type = "default",
  classes = "",
  htmlType,
  disabled,
  id,
  ...style
}: Props) => {
  const mappedClasses = mapClasses({ type, small });

  return (
    <button
      onClick={onClick}
      onMouseDown={onMouseDown}
      className={`tru-button ${mappedClasses} ${classes}`}
      type={htmlType}
      disabled={disabled}
      style={style}
      id={id}
    >
      {children}
    </button>
  );
};
